import styled from 'styled-components'
import Calendar from 'presentation/shared/components/Calendar'

export const Wrapper = styled.div`
  margin-bottom: 32px;
  gap: 32px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);

  @media only screen and (max-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  @media only screen and (max-width: 1080px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media only screen and (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const InputContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin: 24px 0 48px;

  @media only screen and (max-width: 768px) {
    gap: 16px;
  }

  select {
    width: 180px;
  }
`

export const StyledCalendar = styled(Calendar)<{ show: boolean }>`
  position: absolute;
  top: 34px;
  width: 300px;
  display: ${({ show }) => (show ? 'block' : 'none')};
`

export const InputCalendar = styled.div<{ show: boolean }>`
  position: relative;
  svg {
    color: ${({ theme }) => theme.ds.colors.attention400};
  }

  button {
    background: ${({ theme }) => theme.ds.colors.white};
    svg {
      path {
        fill: ${({ theme }) => theme.ds.colors.neutral800};
      }
    }
  }
`
